//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventCategoryDisplayItem } from './EventCategoryDisplayItem';
import { PayrollOverrideType } from './Enums';

export class TeacherPayrollOverrideDisplayItem extends ItemBase {
    Amount: number = 0;
    EventCategoryID: string | null = null;
    EventCategory: EventCategoryDisplayItem | null = null;
    TeacherID: string | null = null;
    Type: PayrollOverrideType = PayrollOverrideType.None;

    constructor(initializer?: Partial<TeacherPayrollOverrideDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherPayrollOverrideDisplayItem";
}
